import React, { Dispatch, FC, SetStateAction } from 'react';
import { StyledPopover, StyledTypography } from './DraftTrajectoryPopoverStyled';

export const DraftTrajectoryPopover: FC<{
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  anchorEl: HTMLElement | null;
}> = ({ open = false, setOpen, anchorEl }) => {
  if (!open) return null;

  return (
    <StyledPopover
      onClose={() => setOpen(false)}
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'center',
        horizontal: 'left',
      }}
      style={{ width: '60%' }}
    >
      <StyledTypography>
        Dit traject kan je nog niet inkijken. Bekijk de voorbeeldtrajecten om een beeld te krijgen
        van de methode.
      </StyledTypography>
    </StyledPopover>
  );
};
